<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="narcoticsbox-trace-list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="[]"
            dialogWidth="65%"
            class="form-table-h360"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            :selection="true"
            @selectionChange="selectionChange"
            @loadingPreparedView="loadingPreparedView"
            @loadingCollectionView="loadingCollectionView"
            @loadingReturnView="loadingReturnView"
            @loadingDetailView="loadingDetailView"
        >
            <slot slot="filter">
                <el-col :md="6" :lg="4" :xl="3" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="wardAuth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="batchPrepare">批量备药</el-button>
            </slot>
        </crud-facecade>
        <form-dialog
            title="批量备药"
            width="70%"
            class="form-table-h360"
            :columns="prepareColumns"
            :data="prepared.data"
            :visible.sync="prepared.dialogFormVisible"
            @confirm="batchPreparation"
        ></form-dialog>
        <form-dialog title="备药" width="70%" class="form-table-h360" :columns="prepareColumns" :data="prepared.data" :visible.sync="prepared.dialogFormVisible" @confirm="preparation"></form-dialog>
        <form-dialog
            title="药箱领用"
            width="60%"
            class="form-table-h360"
            :columns="collectionColumns"
            :data="collection.data"
            :visible.sync="collection.dialogFormVisible"
            @confirm="collecte"
        ></form-dialog>
        <form-dialog title="药箱归还" width="90%" class="form-table-h360" :columns="returnColumns" :data="returnee.data" :visible.sync="returnee.dialogFormVisible" @confirm="returne"></form-dialog>
        <form-dialog title="查看" width="50%" class="form-table-h360" :columns="examineColumns" :data="examine.data" :visible.sync="examine.dialogFormVisible" @confirm="examining"></form-dialog>
        <!-- <SaveAs :visible.sync="saveas.dialogFormVisible" :data="saveas.data" @save-success='saveAsSuccess'></SaveAs> -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SaveAs from './SaveAs.vue'
export default {
    name: `NarcoticsBoxUsed`,
    props: {

    },
    components: { SaveAs },
    data() {
        return {
            title: `药箱请领`,
            dic_ward_id: undefined,
            dic_narcoticsbox: [],
            dic_narcoticsbox_template: [],
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            prepared: {
                dialogFormVisible: false,
                data: {},
                sys_narcotics_box_readonly: true
            },
            collection: {
                dialogFormVisible: false,
                data: {}
            },
            returnee: {
                dialogFormVisible: false,
                data: {}
            },
            examine: {
                dialogFormVisible: false,
                data: {}
            },
            url: { baseURL: `/api/Intraoperative/NarcoticsBoxTrace`,
                get: () => {
                    return this.loadPreparingBoxes()
                } },
            selected: [],
            collectionConfig: (this.$root.NarcoticsBoxCollectionConfig || `0`) == `1`
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
        // this.$store.dispatch("ADD_OPERATION_WARD_AUTH")
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadNarcoticsBox()
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sysuser/workers_by_duty`, `operation_ward_auth`, `recovery_ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        wardAuth() {
            this.dic_ward_id = this.active_ward && this.active_ward.value
            return this.ward_auth
        },
        columnList() {
            return [{
                type: `string`,
                prop: `sys_narcotics_box_id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `name`,
                label: `药箱名称`,
                isListable: true,
                searchable: true
            }, {
                type: `datetime`,
                prop: `prepare_date`,
                label: `备药时间`,
                width: `140`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `preparator`,
                label: `备药者`,
                width: `100`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `receive_date`,
                label: `领用时间`,
                width: `140`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `receiver`,
                label: `领用者`,
                width: `100`,
                isListable: true
            }, {
                type: `string`,
                prop: `register`,
                label: `发放者`,
                width: `100`,
                isListable: true
            }, {
                type: `groupmultiselect`,
                prop: `dic_ward_ids`,
                label: `可用区域`,
                width: `100`,
                isListable: true,
                options: this.ward_auth
                // default:[this.dic_ward_id]
            }, {
                type: `string`,
                prop: `dic_operating_room_name`,
                label: `手术间`,
                width: `100`,
                isListable: true
            }, {
                type: `string`,
                prop: `narcotics_box_trace_status`,
                label: `状态`,
                width: `100`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `190`,
                isListable: true,
                readonly: false,
                options: function(that, { row }) {
                    if (row.box.is_deleted) {
                        return []
                    } else if (row.enum_narcotics_box_trace_status == 0) {
                        return [{
                            class: `is-plain`,
                            label: `备药`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingPreparedView`,
                            permission: `default`
                        }]
                    } else if (row.enum_narcotics_box_trace_status == 1) {
                        return [{
                            class: `is-plain`,
                            label: `重新备药`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingPreparedView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `领用`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingCollectionView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `查看`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingDetailView`,
                            permission: `default`
                        }]
                    } else if (row.enum_narcotics_box_trace_status == 2) {
                        return [{
                            class: `is-plain`,
                            label: `归还`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingReturnView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `查看`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingDetailView`,
                            permission: `default`
                        }]
                    } else if (row.enum_narcotics_box_trace_status == 3) {
                        return [{
                            class: `is-plain`,
                            label: `查看`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingDetailView`,
                            permission: `default`
                        }]
                    }
                },
                fixed: `right`,
                config: {
                    align: `flex-start`
                }
            }]
        },
        prepareColumns() {
            return [{
                type: `multiselect`,
                prop: `sys_narcotics_box`,
                label: `药箱名称`,
                options: this.dic_narcoticsbox,
                colspan: 12,
                readonly: this.prepared.sys_narcotics_box_readonly,
                isKey: true,
                config: {
                    collapseTags: false
                }
            }, {
                type: `select`,
                prop: `template_id`,
                label: `模板选择`,
                // width: "180",
                isListable: true,
                colspan: 12,
                options: this.dic_narcoticsbox_template,
                change: (that, $event) => {
                    if (!$event || !$event.row.template_id) return
                    let { row } = $event
                    let req = this.myaxios.post(`/api/AcisSystem/NarcoticsBoxTemplate/Items/${row.template_id}`)
                    req.then(data => {
                        row.items = data && data.map(d => {
                            let r = {}
                            r.dic_drug = { label: d.drug.name, value: d.dic_drug_id, jianpin: d.drug.abbr }
                            r.spec = d.drug.spec
                            r.unit = d.drug.sell_unit
                            r.quantity = d.quantity
                            r.batch_number = d.batch_no
                            return r
                        })
                        // let extern =_.differenceWith(t_items,row.items,function(arrVal, othVal){
                        //   return arrVal.dic_drug.value == othVal.dic_drug.value
                        // })
                        // row.items.push(...extern)
                    }).catch(e => { console.log(e) })
                }
            }, {
                type: `table`,
                prop: `items`,
                label: `药品列表`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `remoteselect`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true,
                    readonly: false,
                    options: `/api/AcisSystem/Drug/Search`,
                    change: (that, { row, area }) => {
                        let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                        req.then(data => {
                            this.$set(row, `spec`, data && data.spec)
                            this.$set(row, `unit`, data && data.sell_unit)
                        })
                    }
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `200`,
                    isListable: true
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `数量`,
                    width: `80`,
                    isListable: true,
                    readonly: false,
                    default: 1
                }, {
                    type: `string`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `batch_number`,
                    label: `批号`,
                    width: `160`,
                    isListable: true,
                    readonly: false,
                    default: ``
                }],
                colspan: 24,
                default: []
            }]
        },
        collectionColumns() {
            return [{
                type: `table2`,
                prop: `items`,
                label: `药品列表`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `string`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `200`,
                    isListable: true
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `数量`,
                    width: `80`,
                    isListable: true,
                    default: 1
                }, {
                    type: `string`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `batch_number`,
                    label: `批号`,
                    width: `140`,
                    isListable: true,
                    readonly: !this.collectionConfig,
                    default: ``
                }],
                colspan: 24,
                default: []
            }, {
                type: `select`,
                prop: `receiver_id`,
                label: `领用者`,
                readonly: false,
                colspan: 6,
                options: this.worker[`医生`] || [],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `dic_operating_room_id`,
                label: `手术间`,
                readonly: false,
                colspan: 6,
                options: []
            }]
        },
        returnColumns() {
            return [{
                type: `p`,
                prop: `name`,
                label: ` `,
                colspan: 24
            }, {
                type: `table2`,
                prop: `items`,
                label: `药品清单`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `string`,
                    prop: `dic_drug`,
                    label: `药品`,
                    width: `300`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `200`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `batch_number`,
                    label: `批号`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `amount_s`,
                    label: `基数`,
                    width: `60`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `amount_dosage_s`,
                    label: `基数总量`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `use_amount`,
                    label: `空安瓿数`,
                    readonly: false,
                    isListable: true,
                    change: (that, { row }) => {
                        row.remain_amount = row.amount - row.use_amount
                        row.use_dose = (row.use_amount * row.dose) - row.destruction_dose
                    }
                }, {
                    type: `integer`,
                    prop: `remain_amount`,
                    label: `剩余安瓿`,
                    readonly: true,
                    isListable: true
                }, {
                    type: `float`,
                    prop: `use_dose`,
                    label: `总用量`,
                    readonly: false,
                    isListable: true,
                    change: (that, { row }) => {
                        row.destruction_dose = row.amount_dosage - row.use_dose - row.remain_amount * row.dosa
                    }
                }, {
                    type: `float`,
                    prop: `destruction_dose`,
                    label: `销毁总量`,
                    readonly: true,
                    isListable: true
                }],
                colspan: 24,
                default: []
            }, {
                type: `select`,
                prop: `returnee_id`,
                label: `归还人`,
                readonly: false,
                colspan: 6,
                options: this.worker[`医生`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `verifier_name`,
                label: `核对人`,
                readonly: true,
                colspan: 6
            }]
        },
        examineColumns() {
            return [{
                type: `table2`,
                prop: `items`,
                label: `药品清单`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `string`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `200`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `amount_s`,
                    label: `基数`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `batch_number`,
                    label: `批号`,
                    width: `140`,
                    isListable: true
                }],
                colspan: 24,
                default: []
            }, {
                type: `string`,
                prop: `receiver`,
                label: `领用者`,
                readonly: true,
                colspan: 6
            },
            {
                type: `select`,
                prop: `dic_operating_room_name`,
                label: `手术间`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                colspan: 6,
                readonly: false,
                options: (that, { row }) => {
                    let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                        return (d.value == row.dic_recovery_ward_id)
                    })
                    return _.filter(data[0] && data[0].operation_room, (d) => {
                        return d.disabled === false
                    }) || []
                }
            }, {
                type: `string`,
                prop: `register`,
                label: `发送者`,
                readonly: true,
                colspan: 6
            }]
        }
    },
    methods: {
        loadNarcoticsBox() {
            let that = this
            let req = this.myaxios.get(`/api/AcisSystem/NarcoticsBoxTemplate/Get`)
            req.then(data => {
                let groupId = _.groupBy(data, `id`)
                data = _.reduce(groupId, function(result, value, key) {
                    let r = { ...value[0] }
                    r.dic_ward_ids = value.map(d => { return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`) })
                    if (that.dic_ward_id) {
                        if (_.includes(r.dic_ward_ids, that.dic_ward_id)) {
                            result.push(r)
                        }
                    } else {
                        result.push(r)
                    }
                    return result
                }, [])
                this.dic_narcoticsbox_template = _.filter(data, d => {
                    return d.dic_ward_ids.indexOf(this.dic_ward_id) !== -1
                }).map(d => {
                    return { value: d.id, label: d.name, jianpin: d.abbr }
                })
            }).catch(e => {
                this.dic_narcoticsbox_template = []
            })
        },
        loadPreparingBoxes() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Traces`)
                let that = this
                req.then(data => {
                    let groupId = _.groupBy(data, `sys_narcotics_box_id`)
                    let boxs = []
                    _.forEach(groupId, (g) => {
                        let r = { ...g[0] }
                        r.code = r.box.code
                        r.name = r.box.name
                        r.abbr = r.box.abbr
                        r.display_order = r.box.display_order
                        r.narcotics_box_trace_status = r.box.is_deleted ? `已禁用` : r.narcotics_box_trace_status
                        r.dic_ward_ids = g.map(d => { return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`) })
                        if (that.dic_ward_id) {
                            if (_.includes(r.dic_ward_ids, that.dic_ward_id)) {
                                boxs.push(r)
                            }
                        } else {
                            boxs.push(r)
                        }
                    })
                    this.dic_narcoticsbox = _.map(boxs, d => {
                        return { value: d.sys_narcotics_box_id, label: d.name, jianpin: d.abbr }
                    })
                    resolve(_.orderBy(boxs, `display_order`))
                })
            })
        },
        loadingPreparedView($target) {
            let { row } = $target
            let r = { ...row }
            let req
            if (r.id >= 0) {
                req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Drugs/${r.id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                r.sys_narcotics_box = [r.sys_narcotics_box_id]
                r.items = data && data.map(d => {
                    let r = {}
                    r.dic_drug = { label: d.drug.name, value: d.dic_drug_id, jianpin: d.drug.abbr }
                    r.spec = d.drug.spec
                    r.unit = d.drug.sell_unit
                    r.quantity = d.amount
                    r.batch_number = d.batch_number
                    return r
                })
                this.prepared.data = r
                this.prepared.dialogFormVisible = true
            })
        },
        preparation(row) {
            let items = _.filter(row.items, d => { return d.dic_drug && d.dic_drug.value })
            if (items.length == 0) {
                this.$message.error(`备药不能为空`)
                return
            }
            let multiDrug = _.reduce(_.groupBy(items, `dic_drug.value`), function(result, value, key) {
                if (value.length > 1) {
                    result.push(value[0].dic_drug.label)
                }
                return result
            }, [])
            if (multiDrug.length > 0) {
                this.$message.error(`以下药品重复选择：${multiDrug.toString()}`)
                return
            }
            let quantitys = _.map(items, d => {
                return d.quantity
            })
            if (quantitys.indexOf(``) !== -1) {
                this.$message.error(`备药数量为空`)
                return
            }
            let req = this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/Preparation`, {
                box_ids: row.sys_narcotics_box,
                prepare_drugs: items.map(d => {
                    return {
                        dic_drug_id: d.dic_drug.value || d.dic_drug,
                        amount: d.quantity,
                        batch_number: d.batch_number
                    }
                })
            })
            req.then(data => {
                this.ReloadListData()
                this.prepared.dialogFormVisible = false
            })
        },
        loadingCollectionView($target) {
            let { row } = $target
            let r = { ...row }
            if (r.operating_ward_id_data_auth_filter) {
                _.last(this.collectionColumns).options = _.find(this.operation_ward_auth, { value: r.operating_ward_id_data_auth_filter }).operation_room
            } else {
                _.last(this.collectionColumns).options = _.find(this.recovery_ward_auth, { value: r.recovery_ward_id_data_auth_filter }).recovery_bed
            }

            let req
            if (r.id >= 0) {
                req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Drugs/${r.id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                r.items = data && data.map(d => {
                    let r = {}
                    r.id = d.id
                    r.dic_drug = d.drug.name
                    r.spec = d.drug.spec
                    r.unit = d.drug.sell_unit
                    r.quantity = d.amount
                    r.batch_number = d.batch_number
                    return r
                })
                this.collection.data = r
                this.collection.dialogFormVisible = true
            })
        },
        collecte(row) {
            let req = this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/Collection`, {
                'id': row.id,
                'receiver_id': row.receiver_id,
                'dic_operating_room_id': row.dic_operating_room_id,
                'dic_recovery_ward_id': row.dic_recovery_ward_id,
                'prepare_drugs': this.collectionConfig ? row.items : []
            })
            req.then(data => {
                this.ReloadListData()
                this.collection.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        loadingReturnView($target) {
            let { row } = $target
            let r = { ...row }
            let req
            if (r.id >= 0) {
                // 获取归还药箱药品列表
                req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Drugs/${r.id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                r.items = data && data.map(d => {
                    let r = {}
                    r.id = d.id
                    r.dic_drug = d.drug.name
                    r.spec = d.drug.spec
                    r.unit = d.drug.sell_unit
                    r.batch_number = d.batch_number
                    r.amount = d.amount
                    r.amount_s = `${d.amount}${d.drug.sell_unit}`
                    r.amount_dosage = d.amount * d.drug.dose
                    r.amount_dosage_s = r.amount_dosage && `${r.amount_dosage}${d.drug.drug_unit}`
                    r.dosa = d.drug.dose
                    r.use_amount = d.use_amount // 使用支数
                    r.remain_amount = d.remain_amount // 剩余支数
                    r.use_dose = d.use_dose // 使用量
                    r.destruction_dose = d.destruction_dose // 销毁量
                    r.dose = d.drug.dose // 默认剂量
                    return r
                })
                r.returnee_id = r.receiver_id
                r.verifier_name = this.currentUser.dic_worker_name
                r.verifier_id = this.currentUser.dic_worker_id
                // this.returnee.data.boxname = r.name

                this.returnee.data = r
                this.returnee.dialogFormVisible = true
            })
        },
        returne(row) {
            let req = this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/Return`, {
                'id': row.id,
                'returnee_id': row.returnee_id,
                //  "verifier_id":row.verifier_id,
                'prepare_drugs': row.items
            })
            req.then(data => {
                this.ReloadListData()
                this.returnee.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        loadingDetailView($target) {
            let { row } = $target
            let r = { ...row }
            let req
            if (r.id >= 0) {
                req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Drugs/${r.id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                r.items = data && data.map(d => {
                    let r = {}
                    r.id = d.id
                    r.dic_drug = d.drug.name
                    r.spec = d.drug.spec
                    r.unit = d.drug.sell_unit
                    r.batch_number = d.batch_number
                    r.amount = d.amount
                    r.amount_s = `${d.amount}${d.drug.sell_unit}`
                    return r
                })
                // r.dic_operating_room_name =data.dic_operating_room_name
                // r.receiver =data.receiver
                // r.register =data.register
                // console.log(r)
                this.examine.data = r
                this.examine.dialogFormVisible = true
            })
        },
        examining() {
            this.examine.dialogFormVisible = false
        },
        ReloadListData() {
            let that = this
            that.$refs[`narcoticsbox-trace-list`].ReloadListData()
        },
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/NarcoticsBoxTemplate/Post`, {
                    'name': row.name,
                    'code': row.code,
                    'description': row.description,
                    // "display_order":row.display_order,
                    'regions': row.region_type == 1 ? [{ 'owner': this.currentUser.username }] : row.dic_ward_ids.map(d => {
                        return {
                            // "sys_supplies_template_id": 0,
                            'dic_operating_ward_id': _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            'dic_recovery_ward_id': _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    }),
                    'items': row.items.map(d => {
                        return {
                            'id': d.id,
                            'sys_narcotics_box_template_id': row.id,
                            'dic_drug_id': d.dic_drug.value,
                            'quantity': d.quantity
                        }
                    })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadingSaveAsView({ row }) {
            this.loadOne(row).then(data => {
                let r = { ...data }
                this.saveas.dialogFormVisible = true
                r.name = ``
                r.id = 0
                this.saveas.data = r
            }).catch(e => {
                console.log(e)
            })
        },
        saveAsSuccess() {
            this.ReloadListData()
        },
        selectionChange({ row }) {
            this.selected = row
        },
        batchPrepare() {
            let boxs = _.filter(this.selected, d => { return d.enum_narcotics_box_trace_status == 0 && !d.box.is_deleted })
            if (boxs.length == 0) {
                this.$message.warning(`请选择至少一个空药箱`)
                return
            }
            this.prepared.data = {
                sys_narcotics_box: boxs.map(d => d.sys_narcotics_box_id)
            }
            this.prepared.dialogFormVisible = true
        },
        batchPreparation(row) {
            let items = _.filter(row.items, d => { return d.dic_drug && d.dic_drug.value })
            if (items.length == 0) {
                this.$message.error(`备药不能为空`)
                return
            }
            let multiDrug = _.reduce(_.groupBy(items, `dic_drug.value`), function(result, value, key) {
                if (value.length > 1) {
                    result.push(value[0].dic_drug.label)
                }
                return result
            }, [])
            if (multiDrug.length > 0) {
                this.$message.error(`以下药品重复选择：${multiDrug.toString()}`)
                return
            }
            let req = this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/Preparation`, {
                box_ids: row.sys_narcotics_box,
                prepare_drugs: items.map(d => {
                    return {
                        dic_drug_id: d.dic_drug.value || d.dic_drug,
                        amount: d.quantity,
                        batch_number: d.batch_number
                    }
                })
            })
            req.then(data => {
                this.ReloadListData()
                this.prepared.dialogFormVisible = false
            })
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
            this.loadNarcoticsBox()
        }
    }
}
</script>
<style>
.el-form-item.item.name p {
    font-weight: bold;
    color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/NarcoticsBox/Used.vue